import { createGlobalStyle } from 'styled-components';

export const GlobalCss = createGlobalStyle`
  body {
    background: #e4ecf0 !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  [data-cv-test][role='dialog'][aria-modal='true'] {
    background: #fff;
  }

  .fullScreenSpinner {
    background: rgba(24, 53, 88, 0.3);
  }
`;
